export default __webpack_public_path__ + "static/Groupe741-1a299a5d70ed35a807148883e3d46a92.webp";